export default __webpack_public_path__ + "static/media/google.2b5337ed.svg";